import { SilentCronX } from "./SilentCronX.js";
import type { SilentCronXConfig } from "../types/config.js";

export function createSilentCronX(config: SilentCronXConfig = {}): SilentCronX {
  return new SilentCronX(config);
}
